import router, { resetRouter } from './router'
import store from './store'
// import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { title } from './settings'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/404'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  document.title = to.meta.title || title

  // Todo 判断是否在路由白名单中
  if (whiteList.indexOf(to.path) !== -1) {
    next()
  }

  // 判断是否存在用户信息
  if (!store.state.router.hasUserInfo) {
    store.dispatch('getUserInfo').then(() => {
      resetRouter()
      store.dispatch('GenerateRoutes')
      router.addRoutes(store.state.router.asyncRoutes)
      next({ ...to, replace: true })
    })
    return false
  }
  store.dispatch('SetTabs', to)
  // if (to.meta.breadCrumb && from.path == '/') {
  //   next({ ...from })
  //   return false
  // }
  next()
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
